// @ts-nocheck

import { createContext, useContext } from 'react';

import { type MatchStatus } from '../../../types/match';
import { type SportId } from '../../../types/sports';

type LineUpMainViewContextProps = {
  matchId: number;
  sportId: SportId;
  teamId: number | null;
  filterId: string | null;
  sliderValue?: string;
  matchStatus?: MatchStatus;
};

export const LineUpMainViewContext = createContext<LineUpMainViewContextProps>({});

export const useLineUpMainViewContext = () => useContext(LineUpMainViewContext);
